export const VITE_BACKEND_JWT_LS_KEY = import.meta.env.VITE_BACKEND_JWT_LS_KEY || 'jwt_token'

export default VITE_BACKEND_JWT_LS_KEY

export const VITE_ALLOWS_GUEST_ACCESS_TOKEN = import.meta.env.VITE_ALLOWS_GUEST_ACCESS_TOKEN
